import {Inject, Injectable} from '@angular/core';
import {HttpXsrfTokenExtractor} from '@angular/common/http';
import {DOCUMENT} from '@angular/common';

@Injectable()
export class OssHttpXsrfTokenExtractor implements HttpXsrfTokenExtractor {
  constructor(@Inject(DOCUMENT) document: Document) {
  }

  getToken(): string | null {
    const csrfTokenMeta = document.head.querySelector('meta[name="oss-csrf-token"]');
    return csrfTokenMeta?.getAttribute('content');
  }
}
